module.exports = __webpack_public_path__ + "05_face.bbc3940d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer1/05_face.png
// module id = fNCx
// module chunks = 0